export default "__VITE_ASSET__BES$ciRn__"